import { Spin } from 'antd';
import Button from 'components/Button';
import ModalCommon from 'components/Input/ModalCommon';
import { useState } from 'react';
import CourseScheduleServices from 'services/CourseScheduleServices';
import { toast } from 'sonner';

const ModalConfirmDeleteSchedule = ({
  onCancel,
  onSuccess,
  isOpen,
  courseId,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteCourse = () => {
    setLoading(true);
    CourseScheduleServices.deleteCourse(courseId ?? '')
      .then((res) => {
        if (res.isOk) {
          toast.success('養成コースが削除されました。');
          onSuccess();
        }
      })
      .catch((err) =>
        toast.error(
          err?.message || '処理に失敗しました。もう一度お試しください。'
        )
      )
      .finally(() => setLoading(false));
  };
  return (
    <ModalCommon
      title="記事の削除"
      open={isOpen}
      onCancel={onCancel}
      footer={
        <div className="-mt-1 flex h-max justify-end gap-5 border-t border-[#e9e9e9] pt-[15px]">
          <Button btnType="back" width={120} height={40} onClick={onCancel}>
            キャンセル
          </Button>
          <Button onClick={handleDeleteCourse} loading={loading}>
            削除する
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 400,
            color: '#000',
          }}
          className="h-[130px] xl:h-[80px] 2xl:h-[100px]"
        >
          コースの日程を削除してよろしいですか？
          <br />
          削除すると元に戻せません。
        </div>
      </Spin>
    </ModalCommon>
  );
};

export default ModalConfirmDeleteSchedule;
